import React, {useEffect} from 'react';
// import styled from 'styled-components'
import { useTable, useFilters, useGlobalFilter, useAsyncDebounce, useSortBy, useRowSelect } from 'react-table';


import CustomInput from "./CustomInput";

const generateSortingIndicator = column => {
  return column.isSorted ? ( column.isSortedDesc ? " 🔽" : " 🔼") : ""
}

// value and onChange function
const GlobalFilter = ({ globalFilter, setGlobalFilter }) => {
  // console.log(setGlobalFilter, 'global filter')
  return (
    <CustomInput
      value={globalFilter || ""}
      onChange={e => {
        setGlobalFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
      }}
      placeholder={`Cerca ...`}
    />
  );
};

const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef()
    const resolvedRef = ref || defaultRef

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate
    }, [resolvedRef, indeterminate])

    return (
      <div>
        <input type="checkbox" ref={resolvedRef} {...rest} />
      </div>
    )
  }
)

function R7Table({ columns, data, setActiveTutorial }) {


  const defaultColumn = {
    // Let's set up our default Filter UI
    Filter: true,
    minWidth: 10,
    maxWidth: 400
  }

  // const filterTypes
  const filterTypes = {
    text: (rows, id, filterValue) => {
      return rows.filter(row => {
        const rowValue = row.values[id];
        return rowValue !== undefined
          ? String(rowValue)
            .toLowerCase()
            .startsWith(String(filterValue).toLowerCase())
          : true;
      });
    }
  }
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state: { globalFilter },
    setGlobalFilter,
    selectedFlatRows,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      filterTypes
    },
    // hooks for filters
    useFilters,
    useGlobalFilter,
    // hook for sorting
    useSortBy,
    // hooks for resizing
      // useFlexLayout,
      // useResizeColumns,
    // hooks for exander,
      // useExpanded
    // useRowSelect,
    //   hooks => {
    //     hooks.visibleColumns.push(columns => [
    //       // Let's make a column for selection
    //       {
    //         id: 'selection',
    //         // The header can use the table's getToggleAllRowsSelectedProps method
    //         // to render a checkbox
    //         // Header: ({ getToggleAllRowsSelectedProps }) => (
    //         //   <div>
    //         //     <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
    //         //   </div>
    //         // ),
    //         // The cell can use the individual row's getToggleRowSelectedProps method
    //         // to the render a checkbox
    //         Cell: ({ row }) => (
    //           <div>
    //             <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
    //           </div>
    //         ),
    //       },
    //       ...columns,
    //     ])
    //   }

  );

   // useEffect(() => {
   //    const selected = selectedFlatRows.map((row: Row) => row.original);
   //    console.log(selected);
   //    setActiveTutorial(selected[0]);
   //  }, [selectedFlatRows, setActiveTutorial]);

  // Render the UI for your table
  return (

    <div>
      <div className="p-1 border-0 d-flex justify-content-end">

          <GlobalFilter
            globalFilter={globalFilter}
            setGlobalFilter={setGlobalFilter}
          />

      </div>

      <table className="table table-striped" {...getTableProps()}>
        <thead className="thead-dark">
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                  // Add the sorting props to control sorting. For this example
                  // we can add them into the header props
                  <th {...column.getHeaderProps()}>
                    <div {...column.getSortByToggleProps()}>
                      {column.render('Header')}
                      {/* Add a sort direction indicator */}
                      <span>
                        {generateSortingIndicator(column)}
                      </span>
                    </div>
                    <div>{column.canFilter && column.render('Filter')}</div>
                  </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            // console.log(row);
            prepareRow(row)
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {
                  return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                })}
              </tr>
            )
          })}
        </tbody>
      </table>

    </div>
  )
}


export default R7Table
